"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var recaptcha_common_module_1 = require("./recaptcha-common.module");
var recaptcha_loader_service_1 = require("./recaptcha-loader.service");
var recaptcha_value_accessor_directive_1 = require("./recaptcha-value-accessor.directive");
var recaptcha_component_1 = require("./recaptcha.component");
var RecaptchaModule = RecaptchaModule_1 = (function () {
    function RecaptchaModule() {
    }
    RecaptchaModule.forRoot = function () {
        return {
            ngModule: RecaptchaModule_1,
            providers: [recaptcha_loader_service_1.RecaptchaLoaderService],
        };
    };
    return RecaptchaModule;
}());
RecaptchaModule = RecaptchaModule_1 = __decorate([
    core_1.NgModule({
        declarations: [
            recaptcha_value_accessor_directive_1.RecaptchaValueAccessorDirective,
        ],
        exports: [recaptcha_component_1.RecaptchaComponent, recaptcha_value_accessor_directive_1.RecaptchaValueAccessorDirective],
        imports: [forms_1.FormsModule, recaptcha_common_module_1.RecaptchaCommonModule],
    })
], RecaptchaModule);
exports.RecaptchaModule = RecaptchaModule;
var RecaptchaModule_1;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-recaptcha/recaptcha/recaptcha.module.js
// module id = 1382
// module chunks = 0